import { render, staticRenderFns } from "./PaybillCardView.vue?vue&type=template&id=a96bd2a2&scoped=true"
import script from "./PaybillCardView.vue?vue&type=script&lang=js"
export * from "./PaybillCardView.vue?vue&type=script&lang=js"
import style0 from "./PaybillCardView.vue?vue&type=style&index=0&id=a96bd2a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96bd2a2",
  null
  
)

export default component.exports